<template>
  <lb-dialog
    :value="value"
    :heading="copy.heading"
    width="600"
    :loading="loading"
    data-testid="accruals-rerun-rules-dialog"
    @input="$emit('input', $event)"
  >
    <template #body>
      <div class="accruals-rerun-rules-dialog__body" data-testid="accruals-rerun-rules-dialog__body">
        <p class="accruals-rerun-rules-dialog__intro">
          {{ copy.intro }}
        </p>
        <p
          v-if="extraIntro"
          class="accruals-rerun-rules-dialog__intro"
          data-testid="accruals-rerun-rules-dialog__extra-intro"
        >
          {{ extraIntro }}
        </p>
        <p
          v-if="affectedCount != null"
          class="accruals-rerun-rules-dialog__intro"
          data-testid="accruals-rerun-rules-dialog__affected-count"
        >
          {{ affectedCount }} vendor/PO line{{ affectedCount === 1 ? '' : 's' }} will be reset. This cannot be undone.
        </p>

        <div class="accruals-rerun-rules-dialog__impact">
          <span class="accruals-rerun-rules-dialog__impact-bullet" aria-hidden="true">•</span>
          <p class="accruals-rerun-rules-dialog__impact-text">
            {{ copy.impactPrefix }}
            <strong>{{ copy.impactHighlight }}</strong>{{ copy.impactSuffix }}
          </p>
        </div>

        <div
          class="accruals-rerun-rules-dialog__warning"
          role="alert"
          data-testid="accruals-rerun-rules-dialog__warning"
        >
          <img src="/img/accruals/estimates/IconWarning.svg" alt="Warning" class="accruals-rerun-rules-dialog__warning-icon" />
          <div class="accruals-rerun-rules-dialog__warning-copy">
            <p class="accruals-rerun-rules-dialog__warning-title">
              {{ copy.warningTitle }}
            </p>
            <p class="accruals-rerun-rules-dialog__warning-body">
              {{ copy.warningBody }}
            </p>
          </div>
        </div>
      </div>
    </template>

    <template #actions>
      <base-button
        :label="copy.cancelLabel"
        secondary
        :disabled="loading"
        data-testid="accruals-rerun-rules-dialog__cancel-btn"
        @click="$emit('input', false)"
      />
      <base-button
        :label="copy.confirmLabel"
        reject-filled
        class="ml-2"
        :loading="loading"
        :disabled="loading"
        data-testid="accruals-rerun-rules-dialog__confirm-btn"
        @click="$emit('confirm')"
      />
    </template>
  </lb-dialog>
</template>

<script>
import { ACCRUALS_RERUN_RULES_DIALOG } from '../accrualsEstimatesConstants';

export default {
  name: 'AccrualsReRunRulesDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    extraIntro: {
      type: String,
      default: '',
    },
    affectedCount: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      copy: ACCRUALS_RERUN_RULES_DIALOG,
    };
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsReRunRulesDialog.scss';
</style>
